import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'baselineAssessments',
    label: 'Baseline Assessments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
